export const GAME_MEDIA = [
  {
    modeKey: 'easy',
    modeDisplayName: 'Easy',
    videoUrl: "https://www.youtube.com/shorts/gxguj4Tl9Dc",
    music: "/PURPLEKISS.mp3",
  },
  {
    modeKey: 'normal',
    modeDisplayName: 'Normal',
    videoUrl: "https://www.youtube.com/shorts/o-G_WCa9aI8",
    music: "/PURPLEKISS.mp3",
  },
  {
    modeKey: 'hard',
    modeDisplayName: 'Hard',
    videoUrl: "https://www.youtube.com/shorts/nPwqut5K0BI",
    music: "/PURPLEKISS.mp3",
  },
]; 